import { lazy, FC, Suspense } from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
import { MasterLayout } from 'src/_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import { DashboardWrapper } from 'src/app/pages/dashboard/DashboardWrapper'
import { LibraryWrapper } from 'src/app/pages/library/LibraryWrapper'
import { DesignWrapper } from 'src/app/pages/design/DesignWrapper'
import { AdministrationWrapper } from 'src/app/pages/administration/AdministrationWrapper'
import { getCSSVariableValue } from 'src/_metronic/assets/ts/_utils'
import { WithChildren } from 'src/_metronic/helpers'
import MyTasksPage from '../modules/MyTasks/MyTaskPage'

const PrivateRoutes = () => {

  const AdministrationPage = lazy(() => import('src/app/modules/administration/AdministrationPage'))
  const LibraryPage = lazy(() => import('src/app/modules/library/LibraryPage'))
  const DesignPage = lazy(() => import('src/app/modules/design/DesignPage'))
  const ProcessPage = lazy(() => import('src/app/modules/design/components/process-access/ProcessPage'))

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />
        {/* Pages */}
        <Route path='dashboard' element={<DashboardWrapper />} />
        {/* <Route path='library' element={<LibraryWrapper />} /> */}

        <Route
          path='process/process-access/*'
          element={
            <SuspensedView>
              <ProcessPage />
            </SuspensedView>
          }
        />
        {/* Library Modules */}
        <Route
          path='library/*'
          element={
            <SuspensedView>
              <LibraryPage />
            </SuspensedView>
          }
        />

          <Route
          path='my-tasks/*'
          element={
            <SuspensedView>
              <MyTasksPage />
            </SuspensedView>
          }
        />

        <Route
          path='design'
          element={<DesignWrapper />}
        />
        <Route
          path='design/*'
          element={
            <SuspensedView>
              <DesignPage />
            </SuspensedView>
          }
        />

        <Route path='administration' element={<AdministrationWrapper />} />
        <Route
          path='administration/*'
          element={
            <SuspensedView>
              <AdministrationPage />
            </SuspensedView>
          }
        />

        {/* Page Not Found */}
        {/* <Route path='*' element={<Navigate to='/error/404' />} /> */}
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({ children }) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export { PrivateRoutes }
